/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

/// <reference path="../../store.d.ts" />
import defaultStorePlugin from 'store/plugins/defaults';
import expirePlugin from 'store/plugins/expire';
import storeEngine from 'store/src/store-engine';
import memoryStorage from 'store/storages/memoryStorage';
import sessionStorage from 'store/storages/sessionStorage';
import { fg } from '@atlassian/jira-feature-gating';
import { functionWithCondition } from '@jira/platform__utils-feature-flagging-utils/src/utils/function-with-condition/index.tsx';
import cleanUpPlugin from '../storage-cleanup-plugin/index.tsx';

const getPluginsWithCondition = functionWithCondition(
	() => fg('jfp-vulcan-browser-storage-disable-auto-cleanup'),
	() => [defaultStorePlugin],
	() => [defaultStorePlugin, cleanUpPlugin],
);

export const makeSessionStore = (): unknown =>
	storeEngine.createStore([sessionStorage, memoryStorage], getPluginsWithCondition());

export const makeSessionExpirableStore = (): unknown =>
	storeEngine.createStore([sessionStorage, memoryStorage], [defaultStorePlugin, expirePlugin]);
